import { MODULE_BY_PERMISSION } from '../data/modulePermissions';
import { ROLE_GATE } from '../data/roleToShopEnables';

const can = (userRole, shop = {}, requiredPermission) => {
  if (!userRole) return false;
  const moduleName = MODULE_BY_PERMISSION[requiredPermission];
  if (!moduleName) {
    return false;
  }
  const module = userRole.modulePermissions[moduleName];
  if (!module || !module.isEnabled) return false;
  if (ROLE_GATE[requiredPermission] && !ROLE_GATE[requiredPermission](shop)) {
    return false;
  }
  if (module.permissions[requiredPermission] === undefined && process.env.NODE_ENV === 'development') {
    throw new Error(
      `Please check if the required permission "${requiredPermission}" is correctly defined in permissions.js and modulePermissions.js both FE and BE`
    );
  }

  // console.log(requiredPermission, !!module.permissions[requiredPermission]);
  return !!module.permissions[requiredPermission];
};

const canAll = (userRole, shop = {}, ...requiredPermissions) => {
  if (!userRole) return false;
  return requiredPermissions.every(permission => can(userRole, shop, permission));
};

const canAny = (userRole, shop = {}, ...requiredPermissions) => {
  if (!userRole) return false;
  if (requiredPermissions && requiredPermissions[0].includes('payment')) {
    // console.log('requiredPermissions', requiredPermissions);
    // console.log(can(userRole, shop, requiredPermissions[0]));
    // console.log(can(userRole, shop, requiredPermissions[1]));
  }
  return requiredPermissions.some(permission => can(userRole, shop, permission));
};

export { can, canAll, canAny };
